var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImportCsv(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.807,
    height: 19.344,
    viewBox: "0 0 19.807 19.344",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "import-csv",
    transform: "translate(-1613.459 -163.426)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32232",
    "data-name": "Path 32232",
    d: "M18270.641,20538.844v-4.193l-5.973-5.725h-9.428l.217,18.324h12.266",
    transform: "translate(-16641.275 -20365)",
    fill: "none",
    stroke: "#777",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32233",
    "data-name": "Path 32233",
    d: "M18263.838,20529.125v5.6h5.951",
    transform: "translate(-16640.426 -20365)",
    fill: "none",
    stroke: "#777",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32234",
    "data-name": "Path 32234",
    d: "M18269.281,20540.619l-3.344,3.594h2.176v3.057h2.225v-3.057h1.875Z",
    transform: "translate(-16640 -20365)",
    fill: "none",
    stroke: "#777",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    id: "csv",
    transform: "translate(1616 177)",
    fill: "#777",
    fontSize: 9,
    fontFamily: "Oswald-Regular, Oswald",
    letterSpacing: "0.042em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "csv")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportCsv);
export default __webpack_public_path__ + "static/media/import-csv.cf02548052021b0fbcef78a03f64a567.svg";
export { ForwardRef as ReactComponent };